const useFutureCareTable = ({ subsection }) => {
    const rows = Array.isArray(subsection?.tables) ? subsection.tables : [];
    const subtotal = rows.reduce((acc, row) => acc + (Number(row?.lifetimeCost) || 0), 0);

    return { rows, subtotal };
};

export default useFutureCareTable;
